// JAZ Sales - Phase 4 (conversion, customers, onboarding) strings, merged into the Sales dictionary by salesTranslations.js.
// Arabic and English are equal partners: every key exists in both, and every placeholder ({n}, {name}, ...) appears in
// both languages (the i18n check enforces it).
export const customersTranslations = {
  ar: {
    // ---- navigation and page titles
    nav_customers: 'العملاء',
    nav_onboarding: 'التهيئة',
    customers_title: 'العملاء',
    customers_subtitle: 'العملاء المحتملون الذين فازت بهم المبيعات وأصبحوا شركات في JAZ.',
    onb_title: 'التهيئة',
    onb_subtitle: 'متابعة تهيئة العملاء الجدد من الفوز حتى التفعيل.',

    // ---- customer statuses and onboarding stages
    customer_status_active: 'نشط',
    customer_status_onboarding: 'قيد التهيئة',
    customer_status_activated: 'مفعّل',
    onb_stage_won: 'تم الفوز',
    onb_stage_assigned: 'تم الإسناد',
    onb_stage_contacted: 'تم التواصل',
    onb_stage_setup_started: 'بدء الإعداد',
    onb_stage_company_configured: 'تهيئة الشركة',
    onb_stage_employees_added: 'إضافة الموظفين',
    onb_stage_training: 'التدريب',
    onb_stage_activated: 'مفعّل',
    sub_status_active: 'نشط',
    sub_status_expired: 'منتهي',
    sub_status_suspended: 'موقوف',

    // ---- customers list
    cust_col_customer: 'العميل',
    cust_col_status: 'الحالة',
    cust_col_company: 'الشركة في JAZ',
    cust_col_converted: 'تاريخ التحويل',
    cust_col_onboarding: 'التهيئة',
    cust_col_actions: 'إجراءات',
    customers_empty: 'لا يوجد عملاء بعد',
    customers_empty_filtered: 'لا يوجد عملاء بهذه الحالة',
    customers_empty_hint: 'يظهر العميل هنا بعد تحويل عميل محتمل فائز إلى شركة في JAZ.',
    cust_scope_hint: 'تظهر هنا فقط العملاء المرتبطون بعملاء محتملين متاحين لك.',
    cust_search_placeholder: 'اسم النشاط أو جهة الاتصال أو الشركة',
    cust_action_open: 'فتح',
    cust_converted_by: 'حوّله {name}',
    cust_archived_lead: 'العميل المحتمل مؤرشف',

    // ---- customer page
    cust_back: 'العودة إلى العملاء',
    cust_not_found: 'لم يتم العثور على العميل',
    cust_load_error: 'تعذّر تحميل العميل',
    cust_section_company: 'الشركة في JAZ',
    cust_section_contact: 'بيانات التواصل',
    cust_section_conversion: 'التحويل',
    cust_section_onboarding: 'التهيئة',
    cust_field_company: 'اسم الشركة',
    cust_field_subscription: 'حالة الاشتراك',
    cust_field_owner: 'المالك',
    cust_field_owner_email: 'بريد المالك',
    cust_field_owner_phone: 'هاتف المالك',
    cust_field_employees: 'عدد الموظفين',
    cust_field_contact: 'جهة الاتصال',
    cust_field_phone: 'الهاتف',
    cust_field_email: 'البريد الإلكتروني',
    cust_field_city: 'المدينة',
    cust_field_converted_at: 'تاريخ التحويل',
    cust_field_converted_by: 'حوّله',
    cust_company_deleted: 'الشركة محذوفة من JAZ',
    cust_open_lead: 'فتح العميل المحتمل',
    cust_open_onboarding: 'فتح التهيئة',
    cust_no_onboarding_access: 'لا تملك صلاحية عرض التهيئة.',
    cust_onboarding_owner: 'مسؤول التهيئة',

    // ---- onboarding list
    onb_tab_open: 'قيد التنفيذ',
    onb_tab_mine: 'تهيئتي',
    onb_tab_unassigned: 'غير مسندة',
    onb_tab_activated: 'مفعّلة',
    onb_tab_all: 'الكل',
    onb_empty_open: 'لا توجد تهيئة قيد التنفيذ',
    onb_empty_mine: 'لا توجد تهيئة مسندة إليك',
    onb_empty_unassigned: 'كل عمليات التهيئة مسندة',
    onb_empty_activated: 'لا توجد تهيئة مفعّلة بعد',
    onb_empty_all: 'لا توجد عمليات تهيئة',
    onb_empty_hint: 'تبدأ عملية التهيئة تلقائياً عند تحويل عميل محتمل فائز إلى عميل.',
    onb_scope_hint: 'تظهر هنا عمليات التهيئة المتاحة لك فقط.',
    onb_search_placeholder: 'اسم العميل أو جهة الاتصال',
    onb_col_customer: 'العميل',
    onb_col_stage: 'المرحلة',
    onb_col_owner: 'المسؤول',
    onb_col_started: 'بدأت',
    onb_col_actions: 'إجراءات',
    onb_filter_stage: 'المرحلة',
    onb_filter_owner: 'المسؤول',
    onb_filter_owner_me: 'أنا',
    onb_unassigned: 'غير مسندة',
    onb_action_open: 'فتح',
    onb_action_assign: 'إسناد',
    onb_action_reassign: 'إعادة الإسناد',
    onb_action_stage: 'تغيير المرحلة',
    onb_action_notes: 'تعديل الملاحظات',

    // ---- onboarding page
    onb_back: 'العودة إلى التهيئة',
    onb_not_found: 'لم يتم العثور على عملية التهيئة',
    onb_load_error: 'تعذّر تحميل عملية التهيئة',
    onb_section_progress: 'مراحل التهيئة',
    onb_section_contact: 'بيانات التواصل مع العميل',
    onb_section_details: 'التفاصيل',
    onb_section_notes: 'الملاحظات',
    onb_section_timeline: 'السجل',
    onb_section_timeline_hint: 'كل إسناد وتغيير مرحلة وملاحظة مسجّل هنا ولا يمكن تعديله.',
    onb_field_owner: 'المسؤول',
    onb_field_started: 'بدأت في',
    onb_field_completed: 'اكتملت في',
    onb_field_status: 'حالة العميل',
    onb_field_contact: 'جهة الاتصال',
    onb_field_phone: 'الهاتف',
    onb_field_whatsapp: 'واتساب',
    onb_field_email: 'البريد الإلكتروني',
    onb_field_city: 'المدينة',
    onb_notes_empty: 'لا توجد ملاحظات بعد',
    onb_timeline_empty: 'لا توجد أحداث بعد',
    onb_view_customer: 'عرض العميل',
    onb_view_lead: 'عرض العميل المحتمل',
    onb_reopened_hint: 'يمكن إعادة فتح عملية مفعّلة بتغيير مرحلتها.',

    // ---- assign / stage / notes dialogs
    onb_assign_title: 'إسناد التهيئة',
    onb_assign_hint: 'اختر موظف التهيئة الذي سيتولى هذه العملية. تظهر فقط الحسابات النشطة التي تعمل على التهيئة المسندة إليها.',
    onb_assign_none: 'لا يوجد موظف تهيئة نشط يمكن الإسناد إليه. أنشئ حساباً بدور «موظف التهيئة» أو فعّل حساباً موجوداً.',
    onb_assign_open: '{n} قيد التنفيذ',
    onb_assign_current: 'المسؤول الحالي',
    onb_assign_note: 'ملاحظة للسجل',
    onb_assign_confirm: 'إسناد',
    onb_stage_title: 'تغيير مرحلة التهيئة',
    onb_stage_hint: 'المراحل المتاحة تحددها حالة العملية الآن. لا يتغير أي شيء آخر في العميل أو في شركته.',
    onb_stage_pick: 'المرحلة الجديدة',
    onb_stage_note: 'ملاحظة للسجل',
    onb_stage_confirm: 'تغيير المرحلة',
    onb_notes_title: 'ملاحظات التهيئة',
    onb_notes_hint: 'ملاحظات العمل على هذا العميل. كل تعديل يُسجّل في السجل.',
    onb_notes_label: 'الملاحظات',
    onb_notes_save: 'حفظ الملاحظات',

    // ---- conversion: the panel on the lead page
    conv_panel_title: 'التحويل إلى عميل',
    conv_panel_ready: 'هذا العميل المحتمل فائز. حوّله إلى عميل لإنشاء شركته في JAZ وبدء تهيئته.',
    conv_panel_wait: 'هذا العميل المحتمل فائز. يقوم مدير المبيعات بتحويله إلى عميل.',
    conv_panel_converted: 'تم تحويل هذا العميل المحتمل إلى عميل.',
    conv_panel_archived: 'هذا العميل المحتمل مؤرشف. أعد تفعيله لتحويله.',
    conv_panel_view: 'عرض العميل',
    conv_action_convert: 'تحويل إلى عميل',

    // ---- conversion: the dialog
    conv_title: 'تحويل {name} إلى عميل',
    conv_hint: 'سيُنشأ حساب شركة في JAZ وحساب لمالكها، وتبدأ عملية التهيئة. لا يتغير شيء في العميل المحتمل نفسه.',
    conv_field_business_name: 'اسم الشركة',
    conv_field_owner_name: 'اسم المالك',
    conv_field_owner_email: 'بريد المالك',
    conv_field_owner_phone: 'هاتف المالك',
    conv_field_address: 'العنوان',
    conv_field_plan: 'خطة الاشتراك',
    conv_field_password: 'كلمة مرور المالك المبدئية',
    conv_password_hint: 'يستخدمها المالك لتسجيل الدخول أول مرة. لا تُحفظ في المبيعات ولا يمكن عرضها لاحقاً، فانسخها وأرسلها إليه بطريقة آمنة.',
    conv_password_show: 'إظهار كلمة المرور',
    conv_password_hide: 'إخفاء كلمة المرور',
    conv_password_generate: 'توليد',
    conv_password_copy: 'نسخ كلمة المرور',
    conv_plan_employees: 'حتى {n} موظف',
    conv_plan_none: 'لا توجد خطط اشتراك متاحة. أضف خطة من إدارة النظام أولاً.',
    conv_checking: 'جارٍ الفحص...',
    conv_loading: 'جارٍ فحص العميل المحتمل...',
    conv_blockers_title: 'لا يمكن التحويل بعد',
    conv_duplicates_exact_title: 'توجد شركة مطابقة في JAZ',
    conv_duplicates_exact_hint: 'بريد أو هاتف المالك مطابق لشركة موجودة. غيّرهما، فالتحويل سينشئ شركة مكررة.',
    conv_duplicates_possible_title: 'قد توجد شركة مكررة',
    conv_duplicates_possible_hint: 'راجع الشركات التالية. إن كانت شركة مختلفة فعلاً فأكّد المتابعة.',
    conv_confirm_duplicates: 'راجعت التطابقات المحتملة وأريد إنشاء الشركة على أي حال',
    conv_submit: 'تحويل وإنشاء الشركة',
    conv_blocker_lead_not_won: 'لا يمكن تحويل إلا العميل المحتمل الفائز.',
    conv_blocker_lead_archived: 'هذا العميل المحتمل مؤرشف. أعد تفعيله أولاً.',
    conv_blocker_already_converted: 'تم تحويل هذا العميل المحتمل من قبل.',
    conv_blocker_owner_name_required: 'اسم المالك مطلوب.',
    conv_blocker_owner_email_required: 'بريد المالك مطلوب.',
    conv_blocker_owner_phone_required: 'هاتف المالك مطلوب.',
    conv_blocker_owner_email_registered: 'هذا البريد مسجّل لحساب في JAZ. استخدم بريداً آخر.',
    conv_blocker_owner_phone_registered: 'هذا الهاتف مسجّل لحساب في JAZ. استخدم رقماً آخر.',
    conv_blocker_owner_phone_invalid: 'رقم الهاتف غير صالح. لا يجوز أن يحتوي على «@».',
    conv_blocker_company_exists: 'توجد شركة في JAZ لنفس بريد المالك أو هاتفه.',

    // ---- timeline
    event_lead_converted: 'تم التحويل إلى عميل',
    event_onboarding_assigned: 'إسناد التهيئة',
    event_onboarding_stage_changed: 'تغيير مرحلة التهيئة',
    event_onboarding_notes_updated: 'تحديث ملاحظات التهيئة',
    tl_conv_company: 'الشركة',
    tl_conv_plan: 'الخطة',
    tl_onb_status: 'حالة العميل',
    tl_onb_notes: 'الملاحظات',

    // ---- home tiles
    tile_customers_total: 'العملاء',
    tile_onboarding_open: 'تهيئة قيد التنفيذ',
    tile_onboarding_unassigned: 'تهيئة غير مسندة',
    tile_onboarding_mine: 'تهيئتي',

    // ---- toasts
    toast_converted: 'تم تحويل العميل المحتمل وإنشاء الشركة',
    toast_already_converted: 'كان هذا العميل المحتمل محوّلاً من قبل - لم يُنشأ شيء جديد',
    toast_password_copied: 'تم نسخ كلمة المرور',
    toast_onb_assigned: 'تم إسناد التهيئة',
    toast_onb_assign_unchanged: 'التهيئة مسندة إلى هذا الشخص بالفعل',
    toast_onb_stage: 'تم تغيير المرحلة',
    toast_onb_notes: 'تم حفظ الملاحظات',

    // ---- server error codes (err_<code>)
    err_lead_not_won: 'لا يمكن تحويل إلا العميل المحتمل الفائز',
    err_already_converted: 'تم تحويل هذا العميل المحتمل للتو',
    err_owner_email_registered: 'هذا البريد مسجّل لحساب في JAZ. استخدم بريداً آخر.',
    err_owner_phone_registered: 'هذا الهاتف مسجّل لحساب في JAZ. استخدم رقماً آخر.',
    err_owner_phone_invalid: 'رقم الهاتف غير صالح. لا يجوز أن يحتوي على «@».',
    err_owner_name_required: 'اسم المالك مطلوب',
    err_owner_email_required: 'بريد المالك مطلوب',
    err_owner_phone_required: 'هاتف المالك مطلوب',
    err_owner_password_weak: 'كلمة المرور قصيرة جداً (10 أحرف على الأقل)',
    err_plan_not_available: 'خطة الاشتراك المختارة غير متاحة',
    err_company_exists: 'توجد شركة في JAZ لنفس بريد المالك أو هاتفه',
    err_onboarding_assignee_not_eligible: 'لا يمكن إسناد التهيئة إلى هذا الشخص. اختر موظف تهيئة نشطاً.',
    err_onboarding_assignee_required: 'أسنِد التهيئة إلى موظف قبل تغيير مرحلتها',
    err_onboarding_same_stage: 'التهيئة في هذه المرحلة بالفعل',
    err_onboarding_transition_not_allowed: 'لا يمكن الرجوع إلى مرحلة البداية',
    err_onboarding_invalid_stage: 'مرحلة تهيئة غير معروفة',
  },
  en: {
    // ---- navigation and page titles
    nav_customers: 'Customers',
    nav_onboarding: 'Onboarding',
    customers_title: 'Customers',
    customers_subtitle: 'Leads that Sales won and that became companies in JAZ.',
    onb_title: 'Onboarding',
    onb_subtitle: 'Following new customers from won to activated.',

    // ---- customer statuses and onboarding stages
    customer_status_active: 'Active',
    customer_status_onboarding: 'Onboarding',
    customer_status_activated: 'Activated',
    onb_stage_won: 'Won',
    onb_stage_assigned: 'Assigned',
    onb_stage_contacted: 'Contacted',
    onb_stage_setup_started: 'Setup started',
    onb_stage_company_configured: 'Company configured',
    onb_stage_employees_added: 'Employees added',
    onb_stage_training: 'Training',
    onb_stage_activated: 'Activated',
    sub_status_active: 'Active',
    sub_status_expired: 'Expired',
    sub_status_suspended: 'Suspended',

    // ---- customers list
    cust_col_customer: 'Customer',
    cust_col_status: 'Status',
    cust_col_company: 'Company in JAZ',
    cust_col_converted: 'Converted',
    cust_col_onboarding: 'Onboarding',
    cust_col_actions: 'Actions',
    customers_empty: 'No customers yet',
    customers_empty_filtered: 'No customers with this status',
    customers_empty_hint: 'A customer appears here once a won lead has been converted into a JAZ company.',
    cust_scope_hint: 'Only customers that came from leads you have access to are shown here.',
    cust_search_placeholder: 'Business, contact or company name',
    cust_action_open: 'Open',
    cust_converted_by: 'Converted by {name}',
    cust_archived_lead: 'Lead archived',

    // ---- customer page
    cust_back: 'Back to customers',
    cust_not_found: 'Customer not found',
    cust_load_error: 'The customer could not be loaded',
    cust_section_company: 'Company in JAZ',
    cust_section_contact: 'Contact details',
    cust_section_conversion: 'Conversion',
    cust_section_onboarding: 'Onboarding',
    cust_field_company: 'Company name',
    cust_field_subscription: 'Subscription status',
    cust_field_owner: 'Owner',
    cust_field_owner_email: 'Owner email',
    cust_field_owner_phone: 'Owner phone',
    cust_field_employees: 'Employees',
    cust_field_contact: 'Contact',
    cust_field_phone: 'Phone',
    cust_field_email: 'Email',
    cust_field_city: 'City',
    cust_field_converted_at: 'Converted on',
    cust_field_converted_by: 'Converted by',
    cust_company_deleted: 'The company has been deleted from JAZ',
    cust_open_lead: 'Open the lead',
    cust_open_onboarding: 'Open onboarding',
    cust_no_onboarding_access: 'You do not have permission to view onboarding.',
    cust_onboarding_owner: 'Onboarding owner',

    // ---- onboarding list
    onb_tab_open: 'In progress',
    onb_tab_mine: 'My onboarding',
    onb_tab_unassigned: 'Unassigned',
    onb_tab_activated: 'Activated',
    onb_tab_all: 'All',
    onb_empty_open: 'No onboarding in progress',
    onb_empty_mine: 'No onboarding is assigned to you',
    onb_empty_unassigned: 'Every onboarding has an owner',
    onb_empty_activated: 'Nothing has been activated yet',
    onb_empty_all: 'No onboarding yet',
    onb_empty_hint: 'An onboarding starts automatically when a won lead is converted into a customer.',
    onb_scope_hint: 'Only the onboarding you have access to is shown here.',
    onb_search_placeholder: 'Customer or contact name',
    onb_col_customer: 'Customer',
    onb_col_stage: 'Stage',
    onb_col_owner: 'Owner',
    onb_col_started: 'Started',
    onb_col_actions: 'Actions',
    onb_filter_stage: 'Stage',
    onb_filter_owner: 'Owner',
    onb_filter_owner_me: 'Me',
    onb_unassigned: 'Unassigned',
    onb_action_open: 'Open',
    onb_action_assign: 'Assign',
    onb_action_reassign: 'Reassign',
    onb_action_stage: 'Change stage',
    onb_action_notes: 'Edit notes',

    // ---- onboarding page
    onb_back: 'Back to onboarding',
    onb_not_found: 'Onboarding not found',
    onb_load_error: 'The onboarding could not be loaded',
    onb_section_progress: 'Onboarding stages',
    onb_section_contact: 'Customer contact',
    onb_section_details: 'Details',
    onb_section_notes: 'Notes',
    onb_section_timeline: 'History',
    onb_section_timeline_hint: 'Every assignment, stage change and note is recorded here and cannot be edited.',
    onb_field_owner: 'Owner',
    onb_field_started: 'Started on',
    onb_field_completed: 'Completed on',
    onb_field_status: 'Customer status',
    onb_field_contact: 'Contact',
    onb_field_phone: 'Phone',
    onb_field_whatsapp: 'WhatsApp',
    onb_field_email: 'Email',
    onb_field_city: 'City',
    onb_notes_empty: 'No notes yet',
    onb_timeline_empty: 'Nothing has happened yet',
    onb_view_customer: 'View customer',
    onb_view_lead: 'View lead',
    onb_reopened_hint: 'An activated onboarding can be reopened by changing its stage.',

    // ---- assign / stage / notes dialogs
    onb_assign_title: 'Assign onboarding',
    onb_assign_hint: 'Choose the onboarding employee who will run this one. Only active accounts that work the onboarding assigned to them are listed.',
    onb_assign_none: 'There is no active onboarding employee to assign to. Create an account with the "Onboarding Employee" role or reactivate an existing one.',
    onb_assign_open: '{n} in progress',
    onb_assign_current: 'current owner',
    onb_assign_note: 'Note for the history',
    onb_assign_confirm: 'Assign',
    onb_stage_title: 'Change onboarding stage',
    onb_stage_hint: 'The stages offered depend on where the onboarding is now. Nothing else changes on the customer or its company.',
    onb_stage_pick: 'New stage',
    onb_stage_note: 'Note for the history',
    onb_stage_confirm: 'Change stage',
    onb_notes_title: 'Onboarding notes',
    onb_notes_hint: 'Working notes for this customer. Every change is recorded in the history.',
    onb_notes_label: 'Notes',
    onb_notes_save: 'Save notes',

    // ---- conversion: the panel on the lead page
    conv_panel_title: 'Convert to customer',
    conv_panel_ready: 'This lead is won. Convert it to a customer to create its JAZ company and start its onboarding.',
    conv_panel_wait: 'This lead is won. A Sales Manager converts it to a customer.',
    conv_panel_converted: 'This lead has been converted into a customer.',
    conv_panel_archived: 'This lead is archived. Restore it to convert it.',
    conv_panel_view: 'View customer',
    conv_action_convert: 'Convert to customer',

    // ---- conversion: the dialog
    conv_title: 'Convert {name} to a customer',
    conv_hint: 'A JAZ company and an account for its owner will be created, and its onboarding starts. Nothing changes on the lead itself.',
    conv_field_business_name: 'Company name',
    conv_field_owner_name: 'Owner name',
    conv_field_owner_email: 'Owner email',
    conv_field_owner_phone: 'Owner phone',
    conv_field_address: 'Address',
    conv_field_plan: 'Subscription plan',
    conv_field_password: "Owner's initial password",
    conv_password_hint: 'The owner signs in with it the first time. It is not stored in Sales and cannot be shown again, so copy it and send it to them securely.',
    conv_password_show: 'Show password',
    conv_password_hide: 'Hide password',
    conv_password_generate: 'Generate',
    conv_password_copy: 'Copy password',
    conv_plan_employees: 'up to {n} employees',
    conv_plan_none: 'No subscription plan is available. Add one in the system administration first.',
    conv_checking: 'Checking...',
    conv_loading: 'Checking the lead...',
    conv_blockers_title: 'This cannot be converted yet',
    conv_duplicates_exact_title: 'A matching company exists in JAZ',
    conv_duplicates_exact_hint: "The owner's email or phone matches an existing company. Change them - converting would create a duplicate company.",
    conv_duplicates_possible_title: 'This may duplicate a company',
    conv_duplicates_possible_hint: 'Review the companies below. If it really is a different company, confirm to continue.',
    conv_confirm_duplicates: 'I have reviewed the possible matches and want to create the company anyway',
    conv_submit: 'Convert and create company',
    conv_blocker_lead_not_won: 'Only a won lead can be converted.',
    conv_blocker_lead_archived: 'This lead is archived. Restore it first.',
    conv_blocker_already_converted: 'This lead has already been converted.',
    conv_blocker_owner_name_required: "The owner's name is required.",
    conv_blocker_owner_email_required: "The owner's email is required.",
    conv_blocker_owner_phone_required: "The owner's phone number is required.",
    conv_blocker_owner_email_registered: 'This email is already registered to a JAZ account. Use another one.',
    conv_blocker_owner_phone_registered: 'This phone number is already registered to a JAZ account. Use another one.',
    conv_blocker_owner_phone_invalid: "This phone number is not valid: it must not contain '@'.",
    conv_blocker_company_exists: "A JAZ company already exists for this owner's email or phone.",

    // ---- timeline
    event_lead_converted: 'Converted to customer',
    event_onboarding_assigned: 'Onboarding assigned',
    event_onboarding_stage_changed: 'Onboarding stage changed',
    event_onboarding_notes_updated: 'Onboarding notes updated',
    tl_conv_company: 'Company',
    tl_conv_plan: 'Plan',
    tl_onb_status: 'Customer status',
    tl_onb_notes: 'Notes',

    // ---- home tiles
    tile_customers_total: 'Customers',
    tile_onboarding_open: 'Onboarding in progress',
    tile_onboarding_unassigned: 'Unassigned onboarding',
    tile_onboarding_mine: 'My onboarding',

    // ---- toasts
    toast_converted: 'The lead was converted and its company created',
    toast_already_converted: 'This lead had already been converted - nothing new was created',
    toast_password_copied: 'Password copied',
    toast_onb_assigned: 'Onboarding assigned',
    toast_onb_assign_unchanged: 'The onboarding is already assigned to this person',
    toast_onb_stage: 'Stage changed',
    toast_onb_notes: 'Notes saved',

    // ---- server error codes (err_<code>)
    err_lead_not_won: 'Only a won lead can be converted',
    err_already_converted: 'This lead has just been converted',
    err_owner_email_registered: 'This email is already registered to a JAZ account. Use another one.',
    err_owner_phone_registered: 'This phone number is already registered to a JAZ account. Use another one.',
    err_owner_phone_invalid: "This phone number is not valid: it must not contain '@'.",
    err_owner_name_required: "The owner's name is required",
    err_owner_email_required: "The owner's email is required",
    err_owner_phone_required: "The owner's phone number is required",
    err_owner_password_weak: 'The password is too short (at least 10 characters)',
    err_plan_not_available: 'The selected subscription plan is not available',
    err_company_exists: "A JAZ company already exists for this owner's email or phone",
    err_onboarding_assignee_not_eligible: 'The onboarding cannot be given to this person. Choose an active onboarding employee.',
    err_onboarding_assignee_required: 'Assign the onboarding to an employee before changing its stage',
    err_onboarding_same_stage: 'The onboarding is already in this stage',
    err_onboarding_transition_not_allowed: 'An onboarding cannot go back to its starting stage',
    err_onboarding_invalid_stage: 'Unknown onboarding stage',
  },
};
